import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "plan-vista" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = {
  key: 0,
  class: "ctx-modelo"
}
const _hoisted_4 = {
  key: 1,
  class: "subtitulo"
}
const _hoisted_5 = {
  key: 3,
  class: "estado-plan"
}
const _hoisted_6 = { class: "acciones-barra" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "sin-plan-card"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "filtros-barra" }
const _hoisted_12 = { class: "filtros" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "contenedor-tabla" }
const _hoisted_15 = { class: "lista-tabla" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  class: "num"
}
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { key: 4 }
const _hoisted_21 = {
  key: 5,
  class: "texto"
}
const _hoisted_22 = {
  key: 6,
  class: "texto"
}
const _hoisted_23 = { key: 7 }
const _hoisted_24 = { key: 8 }
const _hoisted_25 = {
  key: 9,
  class: "num"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 2,
  class: "mensaje error"
}
const _hoisted_28 = { class: "modal modal-config" }
const _hoisted_29 = { class: "cfg-header" }
const _hoisted_30 = { class: "cfg-body" }
const _hoisted_31 = { class: "cfg-seccion-titulo" }
const _hoisted_32 = { class: "col-config-lista" }
const _hoisted_33 = {
  key: 0,
  class: "col-toggle"
}
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = { class: "toggle-label" }
const _hoisted_36 = {
  key: 1,
  class: "col-toggle-spacer"
}
const _hoisted_37 = ["onUpdate:modelValue", "disabled"]
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = ["disabled", "onClick"]
const _hoisted_40 = ["disabled", "onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "sin-extra"
}
const _hoisted_43 = { class: "cfg-seccion" }
const _hoisted_44 = { class: "nueva-col-form-v2" }
const _hoisted_45 = { class: "seccion-radio-row" }
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "posicion-row" }
const _hoisted_48 = ["value"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "modal-pie" }
const _hoisted_51 = { class: "modal" }
const _hoisted_52 = { class: "modal-titulo" }
const _hoisted_53 = { class: "linea-base" }
const _hoisted_54 = { class: "tabs" }
const _hoisted_55 = {
  key: 0,
  class: "form"
}
const _hoisted_56 = { class: "fila" }
const _hoisted_57 = { class: "fila" }
const _hoisted_58 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_59 = {
  key: 1,
  class: "form"
}
const _hoisted_60 = { class: "chk" }
const _hoisted_61 = { class: "chk" }
const _hoisted_62 = { class: "chk" }
const _hoisted_63 = { class: "fila" }
const _hoisted_64 = ["onUpdate:modelValue"]
const _hoisted_65 = { key: 0 }
const _hoisted_66 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_67 = {
  key: 2,
  class: "form"
}
const _hoisted_68 = { class: "fila" }
const _hoisted_69 = { class: "fila" }
const _hoisted_70 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_71 = { class: "modal-pie" }
const _hoisted_72 = ["disabled"]

import { ref, computed, onMounted, reactive, watch } from 'vue'
import { useRoute } from 'vue-router'
import {
  generarPlanService, getPlanService, actualizarAccionService,
  registrarSeguimientoService, getPlanExportService,
  type PlanMejoramiento, type AccionMejora
} from '@/services/PlanMejoramientoService'
import { getProcesoByIdService } from '@/services/ProcesoAutoevaluacionService'
import type { Proceso } from '@/interfaces/ProcesoAutoevaluacion'
import { exportarPlanInstitucional } from '@/utils/planMejoramientoExport'

type SeccionId = 'accion' | 'recursos' | 'seguimiento'

interface ColumnaConf   { clave: string; titulo: string; visible: boolean; seccion: SeccionId }
interface ColumnaExtra  { id: string; titulo: string; filas: Record<string, string>; seccion: SeccionId }
interface PlanColConfig { columnas: ColumnaConf[]; columnasExtra: ColumnaExtra[]; ordenGlobal: string[] }

interface ColEntry {
  key: string
  tipo: 'sistema' | 'extra'
  clave?: string
  extraCol?: ColumnaExtra
  titulo: string
  visible: boolean
  seccion: SeccionId
}

interface DraftItem {
  key: string
  tipo: 'sistema' | 'extra'
  data: ColumnaConf | ColumnaExtra
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanMejoramientoView',
  setup(__props) {

/**
 * Plan de mejoramiento y fortalecimiento.
 *
 * Acciones con responsable, fechas y avance. Las alertas C4 y C5 vigilan las
 * vencidas y las que van a vencer con avance insuficiente.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/ejecucion/:id_ejecucion/plan-mejoramiento` (PlanMejoramiento) — permiso `planes.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const idEjecucion = Number(route.params.id_ejecucion)

// ── Plan state ────────────────────────────────────────────────────────────────

const cargando   = ref(true)
const generando  = ref(false)
const exportando = ref(false)
const guardando  = ref(false)
const error      = ref('')
const plan       = ref<PlanMejoramiento | null>(null)
const proceso    = ref<Proceso | null>(null)

const filtro = ref<'todas' | 'MEJORAMIENTO' | 'FORTALECIMIENTO'>('todas')
const filtros = [
  { id: 'todas',           label: 'Todas' },
  { id: 'MEJORAMIENTO',    label: 'Mejoramiento' },
  { id: 'FORTALECIMIENTO', label: 'Fortalecimiento' }
] as const

const tiposEntregable = [
  { clave: 'documento',            label: 'Documento' },
  { clave: 'listado',              label: 'Listado' },
  { clave: 'encuesta',             label: 'Encuesta' },
  { clave: 'estadistica',          label: 'Estadística' },
  { clave: 'registro_fotografico', label: 'Registro fotográfico' },
  { clave: 'video',                label: 'Video' },
  { clave: 'grupo_focal',          label: 'Grupo focal' },
  { clave: 'otro',                 label: 'Otro' }
] as const

// ── Configuración de columnas ─────────────────────────────────────────────────

const SECCIONES_UI = [
  { id: 'accion'      as SeccionId, label: 'Acción' },
  { id: 'recursos'    as SeccionId, label: 'Recursos y entregables' },
  { id: 'seguimiento' as SeccionId, label: 'Seguimiento' },
]

const COLS_DEFAULT: ColumnaConf[] = [
  { clave: 'factor',       titulo: 'Factor / Característica', visible: true, seccion: 'accion' },
  { clave: 'calificacion', titulo: 'Calif.',                  visible: true, seccion: 'accion' },
  { clave: 'tipo',         titulo: 'Tipo',                    visible: true, seccion: 'accion' },
  { clave: 'prioridad',    titulo: 'Prioridad',               visible: true, seccion: 'accion' },
  { clave: 'actividad',    titulo: 'Actividad general',       visible: true, seccion: 'accion' },
  { clave: 'responsable',  titulo: 'Responsable',             visible: true, seccion: 'accion' },
  { clave: 'terminacion',  titulo: 'Terminación',             visible: true, seccion: 'accion' },
  { clave: 'estado',       titulo: 'Estado',                  visible: true, seccion: 'seguimiento' },
  { clave: 'avance',       titulo: '% Avance',                visible: true, seccion: 'seguimiento' },
]

const COL_CONFIG_KEY = `plan-col-config-${idEjecucion}`

function cargarColConfig(): PlanColConfig {
  try {
    const raw = localStorage.getItem(COL_CONFIG_KEY)
    if (raw) {
      const saved = JSON.parse(raw) as Record<string, any>
      const merged: ColumnaConf[] = COLS_DEFAULT.map(def => {
        const found = (saved.columnas as any[] | undefined)?.find(c => c.clave === def.clave)
        return found
          ? { ...def, titulo: found.titulo ?? def.titulo, visible: found.visible ?? def.visible }
          : { ...def }
      })
      const extras: ColumnaExtra[] = ((saved.columnasExtra as any[]) ?? []).map((e: any) => ({
        id: e.id, titulo: e.titulo, filas: e.filas ?? {}, seccion: (e.seccion as SeccionId) ?? 'accion'
      }))
      let ordenGlobal: string[] = (saved.ordenGlobal as string[] | undefined) ?? []
      if (!ordenGlobal.length) {
        ordenGlobal = [...merged.map(c => c.clave), ...extras.map(e => e.id)]
      }
      const validKeys = new Set([...merged.map(c => c.clave), ...extras.map(e => e.id)])
      const clean = ordenGlobal.filter(k => validKeys.has(k))
      const missing = [...validKeys].filter(k => !clean.includes(k))
      return { columnas: merged, columnasExtra: extras, ordenGlobal: [...clean, ...missing] }
    }
  } catch (_e) { /* parse error — return defaults */ }
  const cols = COLS_DEFAULT.map(c => ({ ...c }))
  return { columnas: cols, columnasExtra: [], ordenGlobal: cols.map(c => c.clave) }
}

function guardarColConfig(): void {
  localStorage.setItem(COL_CONFIG_KEY, JSON.stringify(colConfig.value))
}

const colConfig = ref<PlanColConfig>(cargarColConfig())

const columnasOrdenadas = computed<ColEntry[]>(() =>
  colConfig.value.ordenGlobal.map(key => {
    const sys = colConfig.value.columnas.find(c => c.clave === key)
    if (sys) return { key, tipo: 'sistema' as const, clave: sys.clave, titulo: sys.titulo, visible: sys.visible, seccion: sys.seccion }
    const ex = colConfig.value.columnasExtra.find(e => e.id === key)
    if (ex) return { key, tipo: 'extra' as const, extraCol: ex, titulo: ex.titulo, visible: true, seccion: ex.seccion }
    return null
  }).filter(Boolean) as ColEntry[]
)

// ── Modal configurar columnas ─────────────────────────────────────────────────

const configModal         = ref(false)
const configDraft         = ref<PlanColConfig>({ columnas: [], columnasExtra: [], ordenGlobal: [] })
const nuevoTituloColExtra = ref('')
const nuevaColSeccion     = ref<SeccionId>('accion')
const nuevaColPosicion    = ref<string>('ultimo')

watch(nuevaColSeccion, () => { nuevaColPosicion.value = 'ultimo' })

function getSeccionDeKeyDraft(key: string): SeccionId | null {
  const sys = configDraft.value.columnas.find(c => c.clave === key)
  if (sys) return sys.seccion
  const ex = configDraft.value.columnasExtra.find(e => e.id === key)
  if (ex) return ex.seccion
  return null
}

function draftSys(key: string): ColumnaConf {
  return configDraft.value.columnas.find(c => c.clave === key)!
}

function draftExtra(id: string): ColumnaExtra {
  return configDraft.value.columnasExtra.find(e => e.id === id)!
}

const configDraftGrupos = computed(() =>
  SECCIONES_UI.map(sec => ({
    ...sec,
    items: configDraft.value.ordenGlobal
      .filter(k => getSeccionDeKeyDraft(k) === sec.id)
      .map(k => {
        const sys = configDraft.value.columnas.find(c => c.clave === k)
        if (sys) return { key: k, tipo: 'sistema' as const, data: sys as ColumnaConf | ColumnaExtra }
        const ex = configDraft.value.columnasExtra.find(e => e.id === k)
        if (ex) return { key: k, tipo: 'extra' as const, data: ex as ColumnaConf | ColumnaExtra }
        return null
      })
      .filter(Boolean) as DraftItem[]
  }))
)

function abrirConfigColumnas(): void {
  configDraft.value = JSON.parse(JSON.stringify(colConfig.value))
  nuevoTituloColExtra.value = ''
  nuevaColSeccion.value = 'accion'
  nuevaColPosicion.value = 'ultimo'
  configModal.value = true
}

function agregarColExtra(): void {
  const titulo = nuevoTituloColExtra.value.trim()
  if (!titulo) return
  const id = crypto.randomUUID()
  const seccion = nuevaColSeccion.value
  const posicion = nuevaColPosicion.value
  const orden = configDraft.value.ordenGlobal
  // Compute insert position BEFORE adding to extras (so getSeccionDeKeyDraft doesn't see the new id yet)
  let insertPos: number
  if (posicion === 'ultimo') {
    const keysEnSec = orden.filter(k => getSeccionDeKeyDraft(k) === seccion)
    const lastKey = keysEnSec[keysEnSec.length - 1]
    insertPos = lastKey ? orden.indexOf(lastKey) + 1 : orden.length
  } else {
    insertPos = orden.indexOf(posicion) + 1
    if (insertPos === 0) insertPos = orden.length
  }
  configDraft.value.columnasExtra.push({ id, titulo, filas: {}, seccion })
  orden.splice(insertPos, 0, id)
  nuevoTituloColExtra.value = ''
  nuevaColPosicion.value = 'ultimo'
}

function eliminarColExtra(id: string): void {
  configDraft.value.columnasExtra = configDraft.value.columnasExtra.filter(c => c.id !== id)
  configDraft.value.ordenGlobal   = configDraft.value.ordenGlobal.filter(k => k !== id)
}

function moverEnSeccionDraft(seccion: SeccionId, key: string, dir: -1 | 1): void {
  const orden = configDraft.value.ordenGlobal
  const keysEnSec = orden.filter(k => getSeccionDeKeyDraft(k) === seccion)
  const idxEnSec = keysEnSec.indexOf(key)
  const idxDestino = idxEnSec + dir
  if (idxDestino < 0 || idxDestino >= keysEnSec.length) return
  const otroKey = keysEnSec[idxDestino]
  const posA = orden.indexOf(key)
  const posB = orden.indexOf(otroKey)
  orden[posA] = otroKey
  orden[posB] = key
}

function aplicarConfig(): void {
  const prevExtras = colConfig.value.columnasExtra
  const next = JSON.parse(JSON.stringify(configDraft.value)) as PlanColConfig
  for (const ec of next.columnasExtra) {
    const prev = prevExtras.find(p => p.id === ec.id)
    if (prev) ec.filas = { ...prev.filas }
  }
  colConfig.value = next
  guardarColConfig()
  configModal.value = false
}

// ── Modal de edición de acción ────────────────────────────────────────────────

const modal             = ref<AccionMejora | null>(null)
const pestana           = ref<'accion' | 'recursos' | 'seguimiento'>('accion')
const mensajeModal      = ref('')
const mensajeModalError = ref(false)
const form              = reactive<Partial<AccionMejora>>({})
const seg               = reactive<Partial<AccionMejora>>({})
const extraColValues    = reactive<Record<string, string>>({})

function extrasDeSeccion(seccion: SeccionId): ColumnaExtra[] {
  return columnasOrdenadas.value
    .filter(c => c.tipo === 'extra' && c.seccion === seccion)
    .map(c => c.extraCol!)
}

function cmpOrdinal(a: string | null | undefined, b: string | null | undefined): number {
  if (!a && !b) return 0
  if (!a) return 1
  if (!b) return -1
  const pa = a.split('.').map(Number)
  const pb = b.split('.').map(Number)
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0)
    if (d !== 0) return d
  }
  return 0
}

const accionesFiltradas = computed(() => {
  const acciones = plan.value?.acciones ?? []
  const filtradas = filtro.value === 'todas' ? acciones : acciones.filter(a => a.tipo === filtro.value)
  return [...filtradas].sort((a, b) => {
    const cP = cmpOrdinal(
      (a.componente?.padre as any)?.ordinal,
      (b.componente?.padre as any)?.ordinal
    )
    if (cP !== 0) return cP
    return cmpOrdinal(
      (a.componente as any)?.ordinal,
      (b.componente as any)?.ordinal
    )
  })
})

function contar(id: string): number {
  const acciones = plan.value?.acciones ?? []
  return id === 'todas' ? acciones.length : acciones.filter(a => a.tipo === id).length
}

function formatFecha(f: string | null | undefined): string {
  if (!f) return '—'
  const d = new Date(f)
  if (isNaN(d.getTime())) return f
  return d.toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' })
}

function pillPrioridad(p: string | null): string {
  return p === 'ALTA' ? 'p-rojo' : p === 'MEDIA' ? 'p-ambar' : 'p-gris'
}

function pillEstado(e: string): string {
  return ({
    NO_INICIADO: 'p-naranja', EN_DESARROLLO: 'p-ambar', CUMPLIDO: 'p-verde',
    NO_CUMPLIDO: 'p-rojo',   ANULADO: 'p-azul'
  } as Record<string, string>)[e] ?? 'p-gris'
}

function abrirModal(a: AccionMejora): void {
  modal.value = a
  pestana.value = 'accion'
  mensajeModal.value = ''
  Object.assign(form, {
    causa_raiz: a.causa_raiz, actividad_general: a.actividad_general,
    actividades_especificas: a.actividades_especificas, tipo: a.tipo, prioridad: a.prioridad,
    responsable_cargo: a.responsable_cargo, fecha_inicio: a.fecha_inicio, fecha_terminacion: a.fecha_terminacion,
    recursos: { h: false, f: false, t: false, ...(a.recursos ?? {}) },
    presupuesto_proyectado: a.presupuesto_proyectado, presupuesto_ejecutado: a.presupuesto_ejecutado,
    entregables: { ...(a.entregables ?? {}) }, fuente_verificacion: a.fuente_verificacion, meta: a.meta,
    por_cumplir: a.por_cumplir
  })
  Object.assign(seg, {
    fecha_seguimiento: a.fecha_seguimiento, estado: a.estado, avance_pct: a.avance_pct,
    fecha_cierre: a.fecha_cierre, observaciones: a.observaciones
  })
  for (const ec of colConfig.value.columnasExtra) {
    extraColValues[ec.id] = ec.filas[String(a.id_accion)] ?? ''
  }
}

async function guardarModal(): Promise<void> {
  if (!modal.value) return
  guardando.value = true
  mensajeModal.value = ''

  const r = pestana.value === 'seguimiento'
    ? await registrarSeguimientoService(modal.value.id_accion, seg)
    : await actualizarAccionService(modal.value.id_accion, form)

  mensajeModalError.value = !r.ok
  mensajeModal.value = r.ok ? 'Guardado' : (r.error ?? 'Error al guardar')

  if (r.ok) {
    if (r.data && plan.value?.acciones) {
      const idx = plan.value.acciones.findIndex(x => x.id_accion === r.data!.id_accion)
      if (idx >= 0) plan.value.acciones[idx] = { ...plan.value.acciones[idx], ...r.data }
    }
    const idAccion = String(modal.value.id_accion)
    for (const ec of colConfig.value.columnasExtra) {
      ec.filas[idAccion] = extraColValues[ec.id] ?? ''
    }
    guardarColConfig()
  }

  guardando.value = false
}

async function generar(): Promise<void> {
  generando.value = true
  error.value = ''
  const r = await generarPlanService(idEjecucion)
  if (r.ok) await cargar()
  else error.value = r.error ?? 'No se pudo generar el plan'
  generando.value = false
}

async function exportar(): Promise<void> {
  if (!plan.value) return
  exportando.value = true
  const r = await getPlanExportService(plan.value.id_plan)
  if (r.ok && r.data) {
    const extrasOrdenados = columnasOrdenadas.value
      .filter(c => c.tipo === 'extra')
      .map(c => c.extraCol!)
    await exportarPlanInstitucional(r.data, extrasOrdenados)
  } else {
    error.value = r.error ?? 'No se pudo exportar'
  }
  exportando.value = false
}

async function cargar(): Promise<void> {
  const r = await getPlanService(idEjecucion)
  if (r.ok && r.data) {
    plan.value = r.data
  } else if (!r.ok && r.status !== 404) {
    error.value = r.error ?? 'No se pudo cargar el plan de mejoramiento'
  }
}

onMounted(async () => {
  const [proc] = await Promise.all([
    getProcesoByIdService(idEjecucion),
    cargar()
  ])
  proceso.value = proc
  cargando.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[38] || (_cache[38] = _createElementVNode("h1", { class: "titulo" }, "Plan de mejoramiento y fortalecimiento", -1)),
        (proceso.value?.version?.nombre)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(proceso.value.version.nombre), 1))
          : _createCommentVNode("", true),
        (plan.value || proceso.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              (proceso.value?.periodo)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[34] || (_cache[34] = _createElementVNode("b", null, "Período:", -1)),
                    _createTextVNode(" " + _toDisplayString(proceso.value.periodo) + "  · ", 1)
                  ], 64))
                : _createCommentVNode("", true),
              (proceso.value?.version?.nombre)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[35] || (_cache[35] = _createElementVNode("b", null, "Versión:", -1)),
                    _createTextVNode(" " + _toDisplayString(proceso.value.version.nombre) + "  · ", 1)
                  ], 64))
                : _createCommentVNode("", true),
              (plan.value?.programa)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[36] || (_cache[36] = _createElementVNode("b", null, "Programa:", -1)),
                    _createTextVNode(" " + _toDisplayString(plan.value.programa) + "  · ", 1)
                  ], 64))
                : _createCommentVNode("", true),
              _cache[37] || (_cache[37] = _createElementVNode("b", null, "Elaboración:", -1)),
              _createTextVNode(" " + _toDisplayString(formatFecha(plan.value?.fecha_elaboracion)) + " ", 1),
              (plan.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(plan.value.estado), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn salir",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ProcesoAutoevaluacionUsuario' })))
        }, "Volver"),
        (plan.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                class: "btn salir",
                disabled: generando.value,
                onClick: generar,
                title: "Añade características nuevas sin tocar lo diligenciado"
              }, " Regenerar ", 8, _hoisted_7),
              _createElementVNode("button", {
                class: "btn guardar",
                disabled: exportando.value,
                onClick: exportar
              }, _toDisplayString(exportando.value ? 'Exportando…' : 'Exportar xlsx'), 9, _hoisted_8)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _cache[79] || (_cache[79] = _createElementVNode("div", { class: "divider" }, null, -1)),
    (!cargando.value && !plan.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _cache[39] || (_cache[39] = _createElementVNode("h2", null, "Esta ejecución no tiene un plan registrado", -1)),
          _cache[40] || (_cache[40] = _createElementVNode("p", null, "Se generará automáticamente desde la matriz de fortalezas y debilidades: acciones de mejoramiento para las debilidades y de fortalecimiento para las fortalezas por consolidar, con prioridad sugerida según el grado de cumplimiento.", -1)),
          _createElementVNode("button", {
            class: "btn guardar",
            disabled: generando.value,
            onClick: generar
          }, _toDisplayString(generando.value ? 'Generando…' : 'Generar Plan'), 9, _hoisted_10)
        ]))
      : _createCommentVNode("", true),
    (plan.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filtros, (f) => {
                return _createElementVNode("button", {
                  key: f.id,
                  class: _normalizeClass(["tab", { activo: filtro.value === f.id }]),
                  onClick: ($event: any) => (filtro.value = f.id)
                }, _toDisplayString(f.label) + " (" + _toDisplayString(contar(f.id)) + ")", 11, _hoisted_13)
              }), 64))
            ]),
            _createElementVNode("button", {
              class: "btn-col-cfg",
              onClick: abrirConfigColumnas
            }, " Columnas ")
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("table", _hoisted_15, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnasOrdenadas.value, (c) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: c.key
                    }, [
                      (c.visible)
                        ? (_openBlock(), _createElementBlock("th", {
                            key: 0,
                            class: _normalizeClass({ 'th-extra': c.tipo === 'extra' })
                          }, _toDisplayString(c.titulo), 3))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  _cache[41] || (_cache[41] = _createElementVNode("th", null, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accionesFiltradas.value, (a) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: a.id_accion
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnasOrdenadas.value, (c) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: c.key
                      }, [
                        (c.visible)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (c.tipo === 'extra')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(c.extraCol!.filas[String(a.id_accion)] ?? ''), 1))
                                : (c.clave === 'factor')
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                      _createElementVNode("b", null, _toDisplayString(a.componente?.padre?.nombre), 1),
                                      _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1)),
                                      _createTextVNode(_toDisplayString(a.componente?.nombre), 1)
                                    ]))
                                  : (c.clave === 'calificacion')
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(a.calificacion?.toFixed(2) ?? '—'), 1))
                                    : (c.clave === 'tipo')
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["pill", a.tipo === 'FORTALECIMIENTO' ? 'p-verde' : 'p-ambar'])
                                          }, _toDisplayString(a.tipo), 3)
                                        ]))
                                      : (c.clave === 'prioridad')
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["pill", pillPrioridad(a.prioridad)])
                                            }, _toDisplayString(a.prioridad ?? '—'), 3)
                                          ]))
                                        : (c.clave === 'actividad')
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(a.actividad_general ?? 'Por diligenciar'), 1))
                                          : (c.clave === 'responsable')
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(a.responsable_cargo ?? '—'), 1))
                                            : (c.clave === 'terminacion')
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(formatFecha(a.fecha_terminacion)), 1))
                                              : (c.clave === 'estado')
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                                                    _createElementVNode("span", {
                                                      class: _normalizeClass(["pill", pillEstado(a.estado)])
                                                    }, _toDisplayString(a.estado.replace('_', ' ')), 3)
                                                  ]))
                                                : (c.clave === 'avance')
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString(a.avance_pct) + "%", 1))
                                                  : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn accion mini",
                        onClick: ($event: any) => (abrirModal(a))
                      }, "Editar", 8, _hoisted_26)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (configModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "modal-fondo",
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (configModal.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _cache[43] || (_cache[43] = _createElementVNode("h3", null, "Configurar columnas", -1)),
              _createElementVNode("button", {
                class: "btn-cerrar",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (configModal.value = false))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configDraftGrupos.value, (grupo) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: grupo.id,
                  class: "cfg-seccion"
                }, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(grupo.label), 1),
                  _createElementVNode("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.items, (item, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.key,
                        class: _normalizeClass(["col-config-fila", { 'col-es-extra': item.tipo === 'extra' }])
                      }, [
                        (item.tipo === 'sistema')
                          ? (_openBlock(), _createElementBlock("label", _hoisted_33, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((draftSys(item.key).visible) = $event)
                              }, null, 8, _hoisted_34), [
                                [_vModelCheckbox, draftSys(item.key).visible]
                              ]),
                              _createElementVNode("span", _hoisted_35, _toDisplayString(draftSys(item.key).visible ? 'Visible' : 'Oculta'), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_36)),
                        (item.tipo === 'sistema')
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 2,
                              "onUpdate:modelValue": ($event: any) => ((draftSys(item.key).titulo) = $event),
                              class: "input-col-titulo",
                              disabled: !draftSys(item.key).visible,
                              placeholder: "Nombre del encabezado"
                            }, null, 8, _hoisted_37)), [
                              [_vModelText, draftSys(item.key).titulo]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 3,
                              "onUpdate:modelValue": ($event: any) => ((draftExtra(item.key).titulo) = $event),
                              class: "input-col-titulo",
                              placeholder: "Nombre de la columna"
                            }, null, 8, _hoisted_38)), [
                              [_vModelText, draftExtra(item.key).titulo]
                            ]),
                        _createElementVNode("button", {
                          class: "btn-mover",
                          disabled: idx === 0,
                          onClick: ($event: any) => (moverEnSeccionDraft(grupo.id, item.key, -1)),
                          title: "Subir"
                        }, "↑", 8, _hoisted_39),
                        _createElementVNode("button", {
                          class: "btn-mover",
                          disabled: idx === grupo.items.length - 1,
                          onClick: ($event: any) => (moverEnSeccionDraft(grupo.id, item.key, +1)),
                          title: "Bajar"
                        }, "↓", 8, _hoisted_40),
                        (item.tipo === 'extra')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 4,
                              class: "btn-elim-col",
                              onClick: ($event: any) => (eliminarColExtra(item.key))
                            }, "✕", 8, _hoisted_41))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128)),
                    (!grupo.items.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_42, "Sin columnas en esta sección."))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_43, [
                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Agregar columna adicional", -1)),
                _cache[48] || (_cache[48] = _createElementVNode("p", { class: "cfg-desc" }, "Se puede editar su valor en el modal de cada acción, en la pestaña de la sección elegida.", -1)),
                _createElementVNode("div", _hoisted_44, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((nuevoTituloColExtra).value = $event)),
                    class: "input-col",
                    placeholder: "Nombre de la columna...",
                    onKeyup: _withKeys(agregarColExtra, ["enter"])
                  }, null, 544), [
                    [_vModelText, nuevoTituloColExtra.value]
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _cache[44] || (_cache[44] = _createElementVNode("span", { class: "seccion-label" }, "Sección:", -1)),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SECCIONES_UI, (sec) => {
                      return _createElementVNode("label", {
                        key: sec.id,
                        class: "seccion-radio"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((nuevaColSeccion).value = $event)),
                          value: sec.id
                        }, null, 8, _hoisted_46), [
                          [_vModelRadio, nuevaColSeccion.value]
                        ]),
                        _createTextVNode(" " + _toDisplayString(sec.label), 1)
                      ])
                    }), 64))
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _cache[46] || (_cache[46] = _createElementVNode("span", { class: "seccion-label" }, "Posición:", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((nuevaColPosicion).value = $event)),
                      class: "select-posicion"
                    }, [
                      _cache[45] || (_cache[45] = _createElementVNode("option", { value: "ultimo" }, "Al final de la sección", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((configDraftGrupos.value.find(g => g.id === nuevaColSeccion.value) ?? { items: [] }).items, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.key,
                          value: item.key
                        }, "Después de \"" + _toDisplayString(item.tipo === 'sistema' ? draftSys(item.key).titulo : draftExtra(item.key).titulo) + "\"", 9, _hoisted_48))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, nuevaColPosicion.value]
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "btn-add-col",
                    disabled: !nuevoTituloColExtra.value.trim(),
                    onClick: agregarColExtra
                  }, " Añadir ", 8, _hoisted_49)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("button", {
                class: "btn salir",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (configModal.value = false))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "btn guardar",
                onClick: aplicarConfig
              }, "Aplicar")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (modal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "modal-fondo",
          onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (modal.value = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("h2", _hoisted_52, _toDisplayString(modal.value.componente?.padre?.nombre) + " → " + _toDisplayString(modal.value.componente?.nombre), 1),
            _createElementVNode("p", _hoisted_53, "Línea de base: " + _toDisplayString(modal.value.linea_base), 1),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("button", {
                class: _normalizeClass(["tab", { activo: pestana.value === 'accion' }]),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (pestana.value = 'accion'))
              }, "Acción", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["tab", { activo: pestana.value === 'recursos' }]),
                onClick: _cache[8] || (_cache[8] = ($event: any) => (pestana.value = 'recursos'))
              }, "Recursos y entregables", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["tab", { activo: pestana.value === 'seguimiento' }]),
                onClick: _cache[9] || (_cache[9] = ($event: any) => (pestana.value = 'seguimiento'))
              }, "Seguimiento", 2)
            ]),
            (pestana.value === 'accion')
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createElementVNode("label", null, [
                    _cache[49] || (_cache[49] = _createTextVNode("Causa raíz de la acción")),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.causa_raiz) = $event)),
                      rows: "2"
                    }, null, 512), [
                      [_vModelText, form.causa_raiz]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[50] || (_cache[50] = _createTextVNode("Actividad general")),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.actividad_general) = $event)),
                      rows: "2"
                    }, null, 512), [
                      [_vModelText, form.actividad_general]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[51] || (_cache[51] = _createTextVNode("Actividades específicas a realizar")),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.actividades_especificas) = $event)),
                      rows: "3"
                    }, null, 512), [
                      [_vModelText, form.actividades_especificas]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("label", null, [
                      _cache[53] || (_cache[53] = _createTextVNode("Tipo de acción ")),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.tipo) = $event))
                      }, _cache[52] || (_cache[52] = [
                        _createElementVNode("option", null, "MEJORAMIENTO", -1),
                        _createElementVNode("option", null, "FORTALECIMIENTO", -1)
                      ]), 512), [
                        [_vModelSelect, form.tipo]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[55] || (_cache[55] = _createTextVNode("Prioridad ")),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.prioridad) = $event))
                      }, _cache[54] || (_cache[54] = [
                        _createElementVNode("option", null, "ALTA", -1),
                        _createElementVNode("option", null, "MEDIA", -1),
                        _createElementVNode("option", null, "BAJA", -1)
                      ]), 512), [
                        [_vModelSelect, form.prioridad]
                      ])
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[56] || (_cache[56] = _createTextVNode("Cargo del responsable de la ejecución")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.responsable_cargo) = $event)),
                      type: "text"
                    }, null, 512), [
                      [_vModelText, form.responsable_cargo]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("label", null, [
                      _cache[57] || (_cache[57] = _createTextVNode("Fecha de inicio")),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.fecha_inicio) = $event)),
                        type: "date"
                      }, null, 512), [
                        [_vModelText, form.fecha_inicio]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[58] || (_cache[58] = _createTextVNode("Fecha de terminación")),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.fecha_terminacion) = $event)),
                        type: "date"
                      }, null, 512), [
                        [_vModelText, form.fecha_terminacion]
                      ])
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[59] || (_cache[59] = _createTextVNode("Meta")),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.meta) = $event)),
                      rows: "2"
                    }, null, 512), [
                      [_vModelText, form.meta]
                    ])
                  ]),
                  (extrasDeSeccion('accion').length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[60] || (_cache[60] = _createElementVNode("hr", { class: "form-divider" }, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extrasDeSeccion('accion'), (ec) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: ec.id
                          }, [
                            _createTextVNode(_toDisplayString(ec.titulo) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((extraColValues[ec.id]) = $event),
                              type: "text",
                              placeholder: `Valor para «${ec.titulo}»`
                            }, null, 8, _hoisted_58), [
                              [_vModelText, extraColValues[ec.id]]
                            ])
                          ]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (pestana.value === 'recursos')
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _createElementVNode("fieldset", null, [
                    _cache[64] || (_cache[64] = _createElementVNode("legend", null, "Recursos", -1)),
                    _createElementVNode("label", _hoisted_60, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.recursos!.h) = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, form.recursos!.h]
                      ]),
                      _cache[61] || (_cache[61] = _createTextVNode(" Humanos"))
                    ]),
                    _createElementVNode("label", _hoisted_61, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.recursos!.f) = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, form.recursos!.f]
                      ]),
                      _cache[62] || (_cache[62] = _createTextVNode(" Físicos"))
                    ]),
                    _createElementVNode("label", _hoisted_62, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.recursos!.t) = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, form.recursos!.t]
                      ]),
                      _cache[63] || (_cache[63] = _createTextVNode(" Tecnológicos"))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("label", null, [
                      _cache[65] || (_cache[65] = _createTextVNode("Presupuesto proyectado")),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.presupuesto_proyectado) = $event)),
                        type: "number",
                        min: "0"
                      }, null, 512), [
                        [
                          _vModelText,
                          form.presupuesto_proyectado,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[66] || (_cache[66] = _createTextVNode("Presupuesto ejecutado")),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((form.presupuesto_ejecutado) = $event)),
                        type: "number",
                        min: "0"
                      }, null, 512), [
                        [
                          _vModelText,
                          form.presupuesto_ejecutado,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])
                  ]),
                  _createElementVNode("fieldset", null, [
                    _cache[68] || (_cache[68] = _createElementVNode("legend", null, "Entregable", -1)),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tiposEntregable, (e) => {
                      return _createElementVNode("label", {
                        key: e.clave,
                        class: "chk"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => (((form.entregables as any)[e.clave]) = $event),
                          type: "checkbox"
                        }, null, 8, _hoisted_64), [
                          [_vModelCheckbox, (form.entregables as any)[e.clave]]
                        ]),
                        _createTextVNode(" " + _toDisplayString(e.label), 1)
                      ])
                    }), 64)),
                    (form.entregables?.otro)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_65, [
                          _cache[67] || (_cache[67] = _createTextVNode("¿Cuál?")),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((form.entregables!.cual) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, form.entregables!.cual]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("label", null, [
                    _cache[69] || (_cache[69] = _createTextVNode("Fuente de verificación (enlace o referencia documental)")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((form.fuente_verificacion) = $event)),
                      type: "text",
                      placeholder: "Enlace, ruta de red o referencia al documento"
                    }, null, 512), [
                      [_vModelText, form.fuente_verificacion]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[70] || (_cache[70] = _createTextVNode("¿Qué falta por cumplir?")),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((form.por_cumplir) = $event)),
                      rows: "2",
                      placeholder: "Describa lo que queda pendiente de esta acción"
                    }, null, 512), [
                      [_vModelText, form.por_cumplir]
                    ])
                  ]),
                  (extrasDeSeccion('recursos').length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[71] || (_cache[71] = _createElementVNode("hr", { class: "form-divider" }, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extrasDeSeccion('recursos'), (ec) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: ec.id
                          }, [
                            _createTextVNode(_toDisplayString(ec.titulo) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((extraColValues[ec.id]) = $event),
                              type: "text",
                              placeholder: `Valor para «${ec.titulo}»`
                            }, null, 8, _hoisted_66), [
                              [_vModelText, extraColValues[ec.id]]
                            ])
                          ]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (pestana.value === 'seguimiento')
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("label", null, [
                      _cache[72] || (_cache[72] = _createTextVNode("Fecha de seguimiento")),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((seg.fecha_seguimiento) = $event)),
                        type: "date"
                      }, null, 512), [
                        [_vModelText, seg.fecha_seguimiento]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[74] || (_cache[74] = _createTextVNode("Estado ")),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((seg.estado) = $event))
                      }, _cache[73] || (_cache[73] = [
                        _createStaticVNode("<option value=\"NO_INICIADO\" data-v-cca24f04>NO INICIADO</option><option value=\"EN_DESARROLLO\" data-v-cca24f04>EN DESARROLLO</option><option value=\"CUMPLIDO\" data-v-cca24f04>CUMPLIDO</option><option value=\"NO_CUMPLIDO\" data-v-cca24f04>NO CUMPLIDO</option><option value=\"ANULADO\" data-v-cca24f04>ANULADO</option>", 5)
                      ]), 512), [
                        [_vModelSelect, seg.estado]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("label", null, [
                      _cache[75] || (_cache[75] = _createTextVNode("% de avance")),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((seg.avance_pct) = $event)),
                        type: "number",
                        min: "0",
                        max: "100"
                      }, null, 512), [
                        [
                          _vModelText,
                          seg.avance_pct,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[76] || (_cache[76] = _createTextVNode("Fecha de cierre")),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((seg.fecha_cierre) = $event)),
                        type: "date"
                      }, null, 512), [
                        [_vModelText, seg.fecha_cierre]
                      ])
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[77] || (_cache[77] = _createTextVNode("Observaciones")),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((seg.observaciones) = $event)),
                      rows: "3"
                    }, null, 512), [
                      [_vModelText, seg.observaciones]
                    ])
                  ]),
                  (extrasDeSeccion('seguimiento').length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[78] || (_cache[78] = _createElementVNode("hr", { class: "form-divider" }, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extrasDeSeccion('seguimiento'), (ec) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: ec.id
                          }, [
                            _createTextVNode(_toDisplayString(ec.titulo) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((extraColValues[ec.id]) = $event),
                              type: "text",
                              placeholder: `Valor para «${ec.titulo}»`
                            }, null, 8, _hoisted_70), [
                              [_vModelText, extraColValues[ec.id]]
                            ])
                          ]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_71, [
              (mensajeModal.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["mensaje", { error: mensajeModalError.value }])
                  }, _toDisplayString(mensajeModal.value), 3))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn salir",
                onClick: _cache[32] || (_cache[32] = ($event: any) => (modal.value = null))
              }, "Cerrar"),
              _createElementVNode("button", {
                class: "btn guardar",
                disabled: guardando.value,
                onClick: guardarModal
              }, _toDisplayString(guardando.value ? 'Guardando…' : 'Guardar'), 9, _hoisted_72)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})